// extracted by mini-css-extract-plugin
export default {"post":"Post_post__cVrun","center":"Post_center__+oWuZ","inline":"Post_inline__5RA9v","comment":"Post_comment__DU3k+","commentAuthor":"Post_commentAuthor__SD1cX"};